import { css } from '@fable/theme'
import { statsColors } from '../../../lib/theme'
import { usePreloadImage } from '@fable/hooks'
import { useState } from 'react'
import { motion } from 'framer-motion'

interface Props {
  index: number
  cover: string
  animate?: boolean
}

export const StreakCalendarBookCover = ({ index, cover, animate }: Props) => {
  const [loaded, setLoaded] = useState(false)
  const img = usePreloadImage(cover, 100)

  const onImageLoad = () => {
    if (img?.src.length) setLoaded(true)
  }

  if (!img?.src.length) return null

  const imgSrc = `${img?.src}&mode=cors`
  const altTag = 'streak book cover'
  const styles = css`
    display: block;
    position: absolute;
    left: calc(30% + ${index * 6}px);
    bottom: 0;
    width: 20px;
    height: 28px;
    object-fit: cover;
    object-position: center;
    border-radius: 2px;
    border: 1px solid ${statsColors.green.bg100};
    background-color: ${statsColors.green.bg100};
    overflow: hidden;
  `

  if (animate) {
    return (
      <motion.img
        variants={{
          hidden: { y: 30 },
          visible: { y: 0 },
        }}
        initial="hidden"
        animate={loaded ? 'visible' : 'hidden'}
        transition={{ duration: 0.2, ease: 'easeOut', delay: index * 0.1 }}
        src={imgSrc}
        alt={altTag}
        className={styles}
        onLoad={onImageLoad}
      />
    )
  }

  return (
    <img src={imgSrc} alt={altTag} className={styles} onLoad={onImageLoad} />
  )
}
